import { FlightSeatPreferenceMap } from "@/types/flights/flight-booking"

export function fieldValueChanged(
  orig: string | boolean | undefined,
  value: string | boolean
) {
  return orig === undefined ? value !== "" : orig !== value
}

export const SubscribeList = [
  { label: "Subscribed", value: "Subscribed" },
  { label: "Unsubscribed", value: "Unsubscribed" },
]

export const SeatPreferenceList = Object.entries(FlightSeatPreferenceMap).map(
  ([key, value]) => {
    return { label: value, value: key }
  }
)

export const SpecialAssistanceMap = {
  baggage_assistance: "Baggage Assistance",
  bind: "Blind",
  deaf: "Deaf",
  language_assistance: "Language Assistance",
  wheel_chair: "Wheel Chair",
  with_infant: "With Infant",
} as const
